import { UploadIcon } from '@heroicons/react/outline'
import React, { FC, useEffect, useState } from 'react'
import { StyledDraftsUploadPhotos } from '.'
import { Spinner } from '../System'
import useDraft from '../../redux/draft-drawer/useDraft'

type Props = {
  onChange: (images: FileList | null) => void;
  processing: boolean;
}

const DraftsUploadPhotos: FC<Props> = ({ onChange, processing }) => {
  const [isDragging, setIsDragging] = useState(false)
  const { isOpened } = useDraft()

  const handleDragOver = (e) => {
    setIsDragging(true)
    e.preventDefault()
  }

  const handleDrop = (e) => {
    setIsDragging(false)
    if (!(e.target instanceof HTMLInputElement)) {
      // prevent file from opening within the browser if dropped outside of the input element
      e.preventDefault()
    }
  }

  const handleDragEnd = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragging(false)
  }

  useEffect(() => {
    if (!isOpened) {
      window.addEventListener('dragover', handleDragOver, false)
      window.addEventListener('drop', handleDrop, false)
      window.addEventListener('dragend', handleDragEnd, false)

      return () => {
        window.removeEventListener('dragover', handleDragOver)
        window.removeEventListener('drop', handleDrop)
        window.removeEventListener('dragend', handleDragEnd)
      }
    }
  }, [isOpened])

  return (
    <StyledDraftsUploadPhotos isDragging={isDragging}>
      {!processing && (
        <>
          <UploadIcon />
          {!isDragging && <span>Upload Photos</span>}
          {isDragging && <span>Drag Here</span>}
        </>
      )}
      {processing && <Spinner size="small" theme="brand" />}
      <input
        type="file"
        name="file"
        multiple
        onChange={(e) => onChange(e.target.files)}
        accept=".png, .jpg, .jpeg, .heic"
      />
    </StyledDraftsUploadPhotos>
  )
}

export default DraftsUploadPhotos
